import React from 'react';
import { Button, message } from 'antd';
import { Link, Navigate } from 'react-router-dom';
import { Localize, localizeByKeyStatic } from 'components/service';
import { usePermissionsContext } from '../context/permissions-context';
import { getAvailableHomeRoute } from '../utils/smart-home-route';

export const SmartHomeButton: React.FC = () => {
  const { hasPermission, isDeveloper } = usePermissionsContext();
  const availableRoute = getAvailableHomeRoute(hasPermission, isDeveloper);

  // If no routes are available, show a message
  if (!availableRoute) {
    return (
      <Button
        type="primary"
        onClick={() => message.error(localizeByKeyStatic('PERMISSION.Error_NoAccessToAnyPage'))}
      >
        <Localize>GLOBAL.Button_Text_BackHome</Localize>
      </Button>
    );
  }

  return (
    <Button type="primary">
      <Link to={availableRoute}>
        <Localize>GLOBAL.Button_Text_BackHome</Localize>
      </Link>
    </Button>
  );
};

export const SmartHomeRedirect: React.FC = () => {
  const { hasPermission, isDeveloper } = usePermissionsContext();
  const availableRoute = getAvailableHomeRoute(hasPermission, isDeveloper);

  return <Navigate to={availableRoute || "/403"} replace />;
};
